import { render, staticRenderFns } from "./audit-details-field-value.component.vue?vue&type=template&id=9ec56b80&scoped=true"
import script from "./audit-details-field-value.component.vue?vue&type=script&lang=ts"
export * from "./audit-details-field-value.component.vue?vue&type=script&lang=ts"
import style0 from "./audit-details-field-value.component.vue?vue&type=style&index=0&id=9ec56b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec56b80",
  null
  
)

export default component.exports